import { Injectable } from '@angular/core';
import { AngularFireDatabase  } from 'angularfire2/database/database';
import { AuthProvider } from '../providers/auth/auth';

@Injectable()
export class PartesService{


  constructor(public afDB: AngularFireDatabase,public auth : AuthProvider,){
    this.usuario = "0";
    //this.usuario =  this.getUsuario();
  }
  usuario : string;
  NombreUsuario : '';
  partes = [];
  cuadrillas = [];
  fincas = [];
  //Metodos set USUARIO
  public setUsuario(item){
    this.usuario = item.aid;
    this.NombreUsuario = item.aNombre;
    this.getPartesOrdenado()
    .subscribe(partes => {
      this.partes = partes;
        });  
  
    this.getCuadrillas()
    .subscribe(cuadrillas => {
      this.cuadrillas = cuadrillas;
        });  

    this.getFincas()
    .subscribe(fincas => {
      this.fincas = fincas;
        });  

  }

  //Añadir,editar y eliminar Partes    
  public editParte(parte){
    this.afDB.database.ref('/encargados/' + this.usuario + '/partes/' + parte.id).set(parte);
  } 

  public deleteParte(parte){
    this.afDB.database.ref('/encargados/' + this.usuario + '/partes/' + parte.id).remove();
  }
  
  public getPartesOrdenado(){
    return this.afDB.list('/encargados/' + this.usuario + '/partes/',{query:{orderByChild: 'Orden'}});
  }
  
  public getPartes(){
    return this.afDB.list('/encargados/' + this.usuario + '/partes/');
  }
  //Devuelve el nombre de Usuari actual
  public getNombreUsuario(){
    return this.NombreUsuario;
  }

  // Añadir y eliminar ENCARGADO
  public addEncargado(encargado){
    this.afDB.database.ref('/encargados/' + encargado.aid + '/').set(encargado);
  } 

  public deleteEncargado(encargado){
    this.afDB.database.ref('/encargados/' + encargado.aid).remove();
  }

  // Añadir y eliminar CUADRILLA
  public addCuadrilla(cuadrilla){
    this.afDB.database.ref('/encargados/' + this.usuario + '/cuadrillas/' + cuadrilla.id + '/').set(cuadrilla);
  } 

  public deleteCuadrilla(cuadrilla){
    this.afDB.database.ref('/encargados/' + this.usuario + '/cuadrillas/' + cuadrilla.id).remove();
  }

  // Añadir y eliminar FINCA
  public addFinca(finca){
    this.afDB.database.ref('/encargados/' + this.usuario + '/fincas/' + finca.idFinca+'-'+ finca.idParcela +'-'+  finca.idProducto+ '/').set(finca);
  } 

  public deleteFinca(finca){
    this.afDB.database.ref('/encargados/' + this.usuario + '/fincas/' + finca.idFinca+'-'+ finca.idParcela +'-'+  finca.idProducto).remove();
  }

  // Añadir y eliminar PERSONAL
  public addPersona(persona){
    this.afDB.database.ref('/personal/' + persona.cuadrilla + '/'+persona.id + '/').set(persona);
  } 

  public deletePersona(persona){
    this.afDB.database.ref('/personal/' + persona.cuadrilla + '/'+persona.id).remove();
  }
  // Añadir y eliminar TAREAS
  public addTarea(tarea){
    this.afDB.database.ref('/tareas/' + tarea.id + '/').set(tarea);
  } 

  public deleteTarea(tarea){
    this.afDB.database.ref('/tareas/ ' + tarea.id).remove();
  }

  public getPersonalCuadrilla(idCuadrilla){
    return this.afDB.list('/personal/'+ idCuadrilla +'/',{query:{orderByChild: 'Nombre'}});
  }
      
  public getCuadrillas(){
    return this.afDB.list('/encargados/' + this.usuario + '/cuadrillas/',{query:{orderByChild: 'Nombre'}});
  }  
  
  public getEncargados(){
    return this.afDB.list('/encargados/',{query:{orderByChild: 'aNombre'}});
  } 

  public getFincas(){
    return this.afDB.list('/encargados/' + this.usuario + '/fincas/',{query:{orderByChild: 'Nombre'}});
  }  
  public getFincasEmpresa(idEmpresa){
    return this.afDB.list('/encargados/' + this.usuario + '/fincas/',{query:{orderByChild: 'idEmpresa',equalTo : idEmpresa}});  
  }
  public getTareas(){
    return this.afDB.list('/tareas/',{query:{orderByChild: 'Nombre'}});
  }  

  public getUsuario(){
    let strUsuario : string;
    strUsuario = this.auth.getUser();
    strUsuario = strUsuario.substring(0,2);
    return strUsuario;
  }

  //Devuelve el idParte siguiente.
  getIdParte(){
    let strUsuario : string;
    let usuario : number;
    let partesArray = [];

    strUsuario = this.usuario;
    strUsuario = strUsuario.substring(1,2);
    usuario = parseInt(strUsuario);

    this.getPartes()
    .subscribe(partes => {
        partesArray = partes;
    });

    if (partesArray.length <= 0){
      return 180000 + usuario * 1000;
    }
    else{
      return partesArray[partesArray.length - 1].id;
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/partes.services.ts